<template>
  <div class="fixed-panel">
    <div v-for="item in button" v-if="options[item].show">
      <el-button :class="['fixed-btn',options[item].class]" type="primary" circle :title="options[item].title" @click="clickBtn(item)"><i :class="['fa',options[item].icon]" aria-hidden="true"></i></el-button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      options: {
        edit: {
          class: '',
          title: '意见反馈',
          icon: 'fa-edit',
          show: true
        },
        back: {
          class: 'btn-back',
          title: '返回顶部',
          icon: 'fa-caret-up',
          show: false
        }
      }
    }
  },
  props: {
    button: {
      type: Array,
      default: []
    }
  },
  created() {
    this.scrollAction()
  },
  methods: {
    clickBtn(btn) {
      this[btn]()
    },
    back() {
      window.scrollTo({ 
        top: 0
      })
    },
    scrollAction() {
      var base = this
      window.addEventListener('scroll', function(e) {
        if(window.scrollY >= 300) {
          base.options.back.show = true
        } else {
          base.options.back.show = false
        }
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import '@/css/style.scss';
.fixed-panel {
  position: fixed;
  bottom: 4%;
  right: 3%;
  z-index: 99;
  .fixed-btn {
    display: block;
    margin: 0 0 15px 0;
    padding: 0;
    width: 40px;
    height: 40px;
    font-size: 14px;
  }
  .btn-back {
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/FixedBar.vue